export const m5l1Solution = `%lang starknet

// Resource
// https://www.cairo-lang.org/docs/how_cairo_works/cairo_intro.html#registers
// https://www.cairo-lang.org/docs/how_cairo_works/functions.html#function-arguments-and-return-values
// do not modify code on this line or above

// Rewrite this function with a high level syntax
@external
func assert_is_42(n : felt) {
    // [ap - 3] = 42
    // ret
    assert n = 42;
    ret;
}

// Rewrite this function with a low level syntax, using registers
@external
func sum(a : felt, b : felt) -> (s : felt) {
    // return (a + b)
    [ap] = [ap -3] + [ap -4], ap++;
    ret;
}

// do not modify code on this line or below

@external
func test_assert_is_42_ok() {
    assert_is_42(42);
    return ();
}

@external
func test_assert_is_42_ko() {
    %{ expect_revert() %}
    assert_is_42(21);
    return ();
}

@external
func test_sum() {
    let (s) = sum(2, 3);
    assert s = 5;
    return ();
}`;
